var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71858 1.52711C9.71858 0.346431 11.5146 0.346431 11.5146 1.52711V12.1393L13.4105 10.2458C14.2463 9.41102 15.5162 10.6793 14.6804 11.5141L11.2515 14.9385C10.9008 15.2888 10.3321 15.2888 9.98164 14.9385L6.55254 11.5138C5.71667 10.679 6.98656 9.41076 7.82243 10.2456L9.71858 12.1393V1.52711ZM18.765 10.5619V17.3434C18.765 18.0875 18.1517 18.7 17.4067 18.7H3.82624C3.0809 18.7 2.46788 18.0875 2.46788 17.3434V10.5619C2.46788 9.38122 0.671875 9.38122 0.671875 10.5619V17.3434C0.671875 19.0783 2.08964 20.4937 3.82624 20.4937H17.4064C19.1435 20.4937 20.5608 19.0777 20.5608 17.3434V10.5619C20.561 9.38122 18.765 9.38122 18.765 10.5619Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c60cd2129fe187e484228e6c97e3dea5.svg";
export { ForwardRef as ReactComponent };